var map = {
	"./ticket-1.png": 156,
	"./ticket-2.png": 84,
	"./ticket-3.png": 157,
	"./ticket-4.png": 158,
	"./ticket-5.png": 159,
	"./ticket-6.png": 160
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 155;